import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetPortfolioDataGqlService {
  readonly document = gql`
    query GetPortfolioData {
      portfolioItems(orderBy: createdAt_DESC) {
        page { 
          name 
        }
        tags
        title
        subTitle
        link
        descriptionAndMedia
      }
    }
  `;
}
